
// Reusable BenefitSection Component
const BenefitSection = ({ title, benefits }) => {
  return (
    <div className="rounded-lg border text-card-foreground shadow-sm bg-dark-secondary border-primary mb-4">
      <div className="p-4">
        {/* Section Title */}
        <h5 className="text-light fw-bold mb-3">{title}</h5>

        {/* Dynamic List */}
        <ul className="list-unstyled">
          {benefits.map((benefit, index) => (
            <li key={index} className="d-flex align-items-center mb-3">
              {/* Icon */}
              <span className="me-3 text-accent">{benefit.icon}</span>

              {/* Texts */}
              <div>
                <h6 className="text-light mb-1">{benefit.heading}</h6>
                <small className="text-muted-custom">{benefit.description}</small>
              </div>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default BenefitSection;